import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryGrid from './components/CategoryGrid';
import HotPosts from './components/HotPosts';
import LatestPosts from './components/LatestPosts';
import MemberActivity from './components/MemberActivity';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function Home() {
  useEffect(() => {
    document.title = '一品楼论坛-官方社区交流平台 | 汇聚优质内容的综合性交流社区';
  }, []);

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '一品楼论坛首页',
    description: '一品楼论坛官方社区交流平台首页，提供最新资讯、热门话题讨论与会员互动入口。',
    url: 'https://adbuluo.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '一品楼论坛',
      url: 'https://adbuluo.cn',
    },
    primaryImageOfPage: {
      '@type': 'ImageObject',
      name: '一品楼论坛首页Banner',
    },
    about: {
      '@type': 'Organization',
      name: '一品楼论坛',
    },
  };

  return (
    <>
      <SchemaOrg data={webpageSchema} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategoryGrid />
          <HotPosts />
          <MemberActivity />
          <LatestPosts />
        </main>
        <Footer />
      </div>
    </>
  );
}